import { computed, onMounted, onUnmounted, ref } from '@vue/composition-api';

export const breakpoints = {
  xs: 380,
  // sm: 460,
  // md: 768,
  // lg: 1024,
  // xl: 1200,
  // '2xl': 1400,
  sm: 768,
  md: 860,
  lg: 1024,
  xl: 1200,
  '2xl': 1400,
};

const containerElement = ref<HTMLDivElement>();
const containerWidth = ref<number>(0);

export const useResponsiveBreakpoints = () => {
  const isXs = computed(() => containerWidth.value >= breakpoints.xs);
  const isSm = computed(() => containerWidth.value >= breakpoints.sm);
  const isMd = computed(() => containerWidth.value >= breakpoints.md);
  const isLg = computed(() => containerWidth.value >= breakpoints.lg);
  const isXl = computed(() => containerWidth.value >= breakpoints.xl);
  const is2xl = computed(() => containerWidth.value >= breakpoints['2xl']);

  return {
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    is2xl,
  };
};

export const useResponsiveDesign = () => {
  let resizeObserver: ResizeObserver | null = null;

  const updateWidth = () => {
    if (containerElement.value) {
      containerWidth.value = containerElement.value.clientWidth;
    }
  };

  onMounted(() => {
    updateWidth();

    if (containerElement.value && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(updateWidth);
      resizeObserver.observe(containerElement.value);
    }

    window.addEventListener('resize', updateWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  return {
    containerElement,
  };
};
